import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Page: StyleRule = ({ theme }) => ({
    width: '100%',
    paddingBottom: theme.siteVariables.spaces['space-24'],
    [theme.screen.laptop]: {
        paddingBottom: 0,
    },
    [theme.screen.max.tablet]: {
        touchAction: 'auto',
    },
});

export const Section: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 50]),
    },
});

export const ContentSection: StyleRule = ({ theme }) => ({
    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 50]),
        [`& > div`]: {
            marginBottom: pxToRem(50),
        },
    },
});
